import { NextPage } from 'next'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { Button } from '@/components/ui/button'
import {
    Card,
    CardContent,
    CardFooter,
    CardHeader,
    CardTitle,
} from '@/components/ui/card'
import { H4, Muted } from '@/components/ui/typography'

const Custom404: NextPage = () => {
    const router = useRouter()

    return (
        <div>
            <Head>
                <title>Page Not Found | Black Crow AI</title>
            </Head>
            <div className="fixed inset-0 ml-64 flex h-full items-center justify-center">
                <Card className="w-full max-w-md shadow-lg">
                    <CardHeader className="space-y-1">
                        <CardTitle className="text-center">
                            <H4>Page Not Found</H4>
                        </CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4 text-center">
                        <Muted>
                            We couldn&apos;t find the page you were looking for.
                            The page might have been removed, had its name
                            changed, or is temporarily unavailable.
                        </Muted>
                    </CardContent>
                    <CardFooter className="flex justify-center space-x-4">
                        <Button variant="outline" onClick={() => router.back()}>
                            Go Back
                        </Button>
                        <Button onClick={() => router.push('/')}>
                            Go Home
                        </Button>
                    </CardFooter>
                </Card>
            </div>
        </div>
    )
}

export default Custom404
